import { DownloadSchedulePDFButton } from "./download-schedule-pdf-button"
import { useSearchParam } from "lib/@hooks/use-search-param"
import { getSharingLink } from "routes/sharing/controller/get-sharing-link"
import { recordShareLinkPrintEvent } from "routes/sharing/controller/record-share-link-print-event"

export function SharingLinkDownloadSchedulePDF() {
    const [share] = useSearchParam("share")
    const link = getSharingLink.useResults(share)
    return !!link?.canDownloadSchedulePDF && <DownloadSchedulePDFButton onPrint={handlePrint} />

    function handlePrint({ schedule, planRoot }) {
        const scheduleId = getScheduleId(schedule)
        if (!scheduleId) return

        recordShareLinkPrintEvent({
            scheduleId,
            regimeId: getRegimeId(planRoot),
        }).catch((error) => {
            console.warn("Failed to record share link print event", error)
        })
    }
}

function getScheduleId(schedule) {
    return schedule?._id ?? schedule?.id
}

function getRegimeId(planRoot) {
    return planRoot?._id ?? planRoot?.id
}
